import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Box, Avatar, Typography, TextField, Button, Paper } from "@mui/material";
import { InfoOutlined, Person } from "@mui/icons-material";
import axios from "axios";

const UserProfile = () => {
  const [userData, setUserData] = useState(null);
  const [summaryData, setSummaryData] = useState(null);
  const navigate = useNavigate();
  const { id } = useParams();

  useEffect(() => {
    if (!id) return;

    axios.get(`http://127.0.0.1:8000/dashboard/profile/${id}`)
      .then((res) => setUserData(res.data))
      .catch((err) => console.error(err));

    axios.get(`http://127.0.0.1:8000/dashboard/profile/data/${id}`)
      .then((res) => setSummaryData(res.data))
      .catch((err) => console.error(err));
  }, [id]);

  if (!userData) return <Typography>Loading...</Typography>;

  return (
    <Box sx={{ mt: 8, px: 2, minHeight: "100vh" }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 2,
        }}
      >
        <Typography
          sx={{ color: "#888", cursor: "pointer" }}
          onClick={() => navigate("/dashboard")}
        >
          &lt; Back
        </Typography>
        <Button
          variant="contained"
          sx={{ borderRadius: 20, textTransform: "none", px: 3 }}
          onClick={() => navigate(`/Editprofile/${id}`)}
        >
          Edit
        </Button>
      </Box>

      {/* Main Container */}
      <Paper
        elevation={0}
        sx={{
          borderRadius: 3,
          p: 3,
          display: "flex",
          alignItems: "stretch",
          gap: 4,
        }}
      >
        {/* Left Profile Box */}
        <Paper
          elevation={0}
          sx={{
            width: 220,
            border: "1px solid #ddd",
            borderRadius: 3,
            textAlign: "center",
            p: 2,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
          }}
        >
          <Avatar
            sx={{
              width: 80,
              height: 80,
              margin: "auto",
              bgcolor: "#c5c5c5",
            }}
          >
            <Person sx={{ fontSize: 40 }} />
          </Avatar>
          <Typography
            sx={{ fontWeight: 600, fontSize: "18px", color: "#0A66C2", mt: 1 }}
          >
            {userData.name}
          </Typography>
          <Typography sx={{ color: "#888", fontSize: 13 }}>
            Member since Sep 3, 2023
          </Typography>
        </Paper>

        {/* Right Info Box */}
        <Box sx={{ flexGrow: 1, maxWidth: 600 }}>
          <Typography
            sx={{ fontWeight: 500, color: "#787c84" }}>Email Id</Typography>
          <Box sx={{ display: "flex", alignItems: "center", mt: 1, gap: 0.8 }}>
            <TextField
              variant="outlined"
              size="small"
              fullWidth
              value={userData.email}
              InputProps={{
                readOnly: true,
                sx: {
                  color: "#787c84",
                  borderRadius: "10px",
                },
              }}
            />
            <Button
              variant="text"
              // size="small"
              sx={{
                color: "red",
                textTransform: "none",
                display: "flex",
                alignItems: "center",
                gap: "4px", 
                minWidth: "auto",
                px: 0.5,
                fontSize: 12,
                whiteSpace: "nowrap",
              }}
            >
              verify now
              <InfoOutlined sx={{ fontSize: 16 }} />
            </Button>
          </Box>


          <Typography sx={{ mt: 3, fontWeight: 500, color: "#787c84" }}>Contact No.</Typography>
          <Box sx={{ display: "flex", mt: 1 }}>
            <TextField
              size="small"
              value="+91"
              sx={{ width: 70, mr: 1 }}
              InputProps={{
                readOnly: true,
                sx: {
                  color: "#787c84",
                  borderRadius: "10px",
                },
              }}
            />
            <TextField
              size="small"
              value={userData.phone_number}
              fullWidth
              InputProps={{
                readOnly: true,
                sx: {
                  color: "#787c84",
                  borderRadius: "10px",
                },
              }}
            />
          </Box>
        </Box>
      </Paper>

      {/* 🔽 Summary Box Below Main */}
      {summaryData && (
        <Paper
          elevation={0}
          sx={{
            mt: 3,
            ml: 0,
            borderRadius: 3,
            p: 2,
            backgroundColor: "#fff",
            width: 450,
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              py: 1,
              borderBottom: "1px solid #eee",
            }}
          >
            <Typography sx={{ fontWeight: 500, fontSize: 16 }}>
              Total expenses
            </Typography>
            <Typography sx={{ fontWeight: 500, fontSize: 16, color: "#787c84" }}>
              {summaryData.total_expense.toLocaleString()}
            </Typography>
          </Box>

          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              py: 1,
              borderBottom: "1px solid #eee",
            }}
          >
            <Typography sx={{ fontWeight: 600, fontSize: 16 }}>Diary’s</Typography>
            <Typography sx={{ fontWeight: 500, fontSize: 16, color: "#787c84" }}>
              {summaryData.total_trackers}
            </Typography>
          </Box>

          <Box sx={{ display: "flex", justifyContent: "space-between", py: 1 }}>
            <Typography sx={{ fontWeight: 600, fontSize: 16 }}>Bill’s</Typography>
            <Typography sx={{ fontSize: 16, fontWeight: 500, color: "#787c84" }}>
              {summaryData.total_bills}
            </Typography>
          </Box>
        </Paper>
      )}
    </Box>
  );
};

export default UserProfile;
